// Our main CSS
import '../css/app.css'

/**
 * Vue is ready for you, if you need it.
 */

/**
 * The following block of code automatically registers your Vue components.
 * It will recursively scan this directory for the Vue components and
 * automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 *
 * Feel free to remove this block if you don't like black magic fuckery,
 * or you want to register your Vue components manually.
 */
/*
 *** https://v3.vuejs.org/
 */
// interface ImportedModule {
//   name: string
//   default: object
// }
// const vueSingleFileComponents = import.meta.glob<ImportedModule>('./**/*.vue', {
//   eager: true
// })

// import { createApp } from 'vue'
// const app = createApp({})

// for (const path in vueSingleFileComponents) {
//   const importedModule = vueSingleFileComponents[String(path)]
//   const name = path.split('/').pop()?.split('.')[0]
//   if (name !== undefined && typeof name === 'string') {
//     app.component(name, importedModule.default)
//   }
// }
// app.mount('#vue-app')

/**
OR:

Load a js-module dynamically, if the parent element exists, in this example, a vue component. (The js-file wont load if html element with id #ExampleVueComponentWrapper does not exists)
*/

/**
const ExampleVueComponentWrapper = document.getElementById(
  'ExampleVueComponentWrapper'
)
if (ExampleVueComponentWrapper && ExampleVueComponentWrapper !== null) {
  import('./ExampleVueComponent/index.js')
    .then((module) => {
      module.default(ExampleVueComponentWrapper as HTMLElement)
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}
*/

/**
 * 🦄: Now do your magic.
 */

const jsHero = document.querySelectorAll('.js-hero')

if (jsHero && jsHero.length > 0) {
  import('./modules/heroImages').then((module) => {
    module.default()
  }
  )
}

const jsHasFadeIn = document.querySelectorAll('.splash-fade-in')
if (jsHasFadeIn && jsHasFadeIn.length > 0) {
  import('./modules/fadeIn').then((module) => {
    module.default()
  })
}

const jsExpand = document.querySelectorAll('.js-expand')

if (jsExpand && jsExpand.length > 0) {
  import('./modules/projectDetails').then((module) => {
    module.default()
  })
}

const jsClipboard = document.querySelectorAll('.js-clipboard')

if (jsClipboard && jsClipboard.length > 0) {
  import('./modules/clipboard').then((module) => {
    module.default()
  })
}

const jsContactModal = document.querySelectorAll('[data-contact-modal]')

if (jsContactModal && jsContactModal.length > 0) {
  import('./modules/contactModal').then((module) => {
    module.default()
  })
}

const jsRive = document.querySelectorAll('.js-rive')

if (jsRive && jsRive.length > 0) {
  import('./modules/riveEyes').then((module) => {
    module.default()
  })
}

const menuEyes = document.querySelectorAll('.menu-eyes')

if (menuEyes && menuEyes.length > 0) {
  import('./modules/riveEyesMenu').then((module) => {
    module.default()
  })
}

const jsMarquee = document.querySelectorAll('.js-marquee')
if (jsMarquee && jsMarquee.length > 0) {
  import('./modules/marquee').then((module) => {
    module.default()
  })
}

const jsAgencyList = document.querySelectorAll('.js-agency-list')
if (jsAgencyList && jsAgencyList.length > 0) {
  import('./modules/agencyList').then((module) => {
    module.default()
  })
}

const jsExpandableText = document.querySelectorAll('.js-expandable-text')
if (jsExpandableText && jsExpandableText.length > 0) {
  import('./modules/expandableText').then((module) => {
    module.default()
  })
}

const jsParallax = document.querySelectorAll('.js-parallax')
if (jsParallax && jsParallax.length > 0) {
  import('./modules/parallax').then((module) => {
    module.default()
  })
}

/*
const jsPlayer = document.querySelectorAll('.js-player')

if (jsPlayer && jsPlayer.length > 0) {
  import('./modules/plyrPlayer').then((module) => {
    module.default()
  })
}*/

document.addEventListener('DOMContentLoaded', () => {
  // Initialize variables
  let lastScrollTop = 0;
  const pageMenu = document.querySelector('.page-menu');
  const menuToggles = document.querySelectorAll('.menu-toggle');
  const overlayMenu = document.querySelector('.overlay-menu');

  // Handler for scroll events
  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop < 100) {
      // At the top
      pageMenu.classList.remove('hide');
    } else if (scrollTop > lastScrollTop) {
      // Scrolling down and not at the top
      pageMenu.classList.add('hide');
      pageMenu.classList.remove('show');
    } else {
      // Scrolling up or at the top
      pageMenu.classList.remove('hide');
      pageMenu.classList.add('show');
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
  };

  // Handler for menu toggle clicks
  const toggleOverlayMenu = () => {
    overlayMenu.classList.toggle('visible');
    const isVisible = overlayMenu.classList.contains('visible');

    if (isVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  };

  // Add event listeners
  window.addEventListener('scroll', handleScroll);

  menuToggles.forEach((toggle) => {
    toggle.addEventListener('click', toggleOverlayMenu);
  });

  // Optional: Cleanup event listeners when the page is unloaded
  // This is generally not necessary unless you're dynamically adding/removing components
  window.addEventListener('beforeunload', () => {
    window.removeEventListener('scroll', handleScroll);
    menuToggles.forEach((toggle) => {
      toggle.removeEventListener('click', toggleOverlayMenu);
    });
  });
});
